export const EMAILS_DOMAIN = 'app/modules/Contents/EMAILS_DOMAIN';
export const REQUEST_EMAIL_HISTORY = 'app/modules/Contents/REQUEST_EMAIL_HISTORY';
export const REQUEST_EMAIL_HISTORY_FILTER = 'app/modules/Contents/REQUEST_EMAIL_HISTORY_FILTER';

export const FILTER_DEFAULT_LIMIT = 100;
